import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ScrollableDialog from '../common/ScrollableDialog';
import { formatCalendarDate } from '../../utils/dateFormatUtils';
import { formatCurrency } from '../../utils/currencyUtils';
import { formatStockQuantity } from '../../utils/stockQuantityUtils';

const StockPurchaseDetailsDialog = ({ open, purchase, currency, onClose }) => {
  const { t } = useTranslation();
  if (!purchase) {
    return null;
  }

  return (
    <ScrollableDialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      title={t('stock.purchases.detailsTitle')}
      dividers
      showCloseButton
      titleSx={{ pb: 1, flexShrink: 0 }}
    >
      <Box id="stock-purchase-details" sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="body2">{purchase.supplierName || t('stock.purchases.noSupplier')}</Typography>
        <Typography variant="body2">{formatCalendarDate(purchase.purchaseDate)}</Typography>
        <Typography variant="body2">{purchase.invoiceReference}</Typography>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          {formatCurrency(purchase.totalAmount, currency)}
        </Typography>
        {(purchase.lines || []).map((line) => (
          <Typography key={`${line.productId}-${line.productName}`} variant="body2">
            {`${line.productName}: ${formatStockQuantity({
              stockOnHand: line.packageQuantity * (line.contentQuantity || 1),
              contentQuantity: line.contentQuantity,
              stockUnit: line.stockUnit,
            })} · ${formatCurrency(line.lineTotal, currency)} · ${Number(line.vatRate) || 0}%`}
          </Typography>
        ))}
      </Box>
    </ScrollableDialog>
  );
};

export default StockPurchaseDetailsDialog;
